import type { FC } from "react";
import styled from "styled-components";
import { Breakpoint, useMediaQuery } from "@stubhub/broadway-providers";
import type { LinkItem } from "src/http/api-types";
import { useCarouselPaging } from "src/shared/hooks/useCarouselPaging";
import { CarouselWithArrows } from "src/website-apps/shared/components/carousel";
import { StyledCarousel, StyledNext, StyledPrev } from "src/website-apps/shared/components/carousel/CarouselWithArrows";
import { TeamCard } from "../TeamCard";

const StyledTeamsNearYouCarousel = styled.div`
  ${StyledPrev} {
    box-shadow: ${(props) => `0 0 4px 0 ${props.theme.colors.textDarker}`};
    top: 50%;
  }

  ${StyledNext} {
    box-shadow: ${(props) => `0 0 4px 0 ${props.theme.colors.textDarker}`};
    top: 50%;
  }

  ${StyledCarousel} {
    margin-right: ${(props) => props.theme.spacing(4)};
  }
`;

const StyledTeamCard = styled(TeamCard)`
  height: auto;
  margin-right: ${(props) => props.theme.spacing(4)};
  @media ${({ theme: { media } }) => `${media.tablet}, ${media.desktop}`} {
    &:hover {
      background-color: #edeff0;
    }
  }
`;

interface Props {
  id: string;
  onClick: (() => void) | undefined;
  teams: LinkItem[];
}

/**
 * Teams Near You Carousel UI (Desktop & Tablet)
 */
export const TeamsNearYouCarousel: FC<Props> = ({ id, onClick, teams }) => {
  const isDesktop = useMediaQuery(Breakpoint.Desktop);
  const isTabletUp = useMediaQuery(Breakpoint.Tablet);
  const isTablet = isTabletUp && !isDesktop;
  const { onNextArrowClick, onPrevArrowClick, page, remaining } = useCarouselPaging({
    data: teams,
    id,
    pageSize: 3,
  });

  return (
    <StyledTeamsNearYouCarousel>
      <CarouselWithArrows
        fluidHeight
        id={id}
        items={teams}
        onNext={onNextArrowClick}
        onPrev={onPrevArrowClick}
        page={page}
        pageSize={isTablet ? 2 : 3}
        remain={remaining}
        renderItem={(team: LinkItem) => <StyledTeamCard key={team.id} onClick={onClick} {...team} />}
      />
    </StyledTeamsNearYouCarousel>
  );
};
